import { render, staticRenderFns } from "./newallocate.vue?vue&type=template&id=140edd83&scoped=true"
import script from "./newallocate.vue?vue&type=script&lang=js"
export * from "./newallocate.vue?vue&type=script&lang=js"
import style0 from "./newallocate.vue?vue&type=style&index=0&id=140edd83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140edd83",
  null
  
)

export default component.exports